export enum BookingServiceCode {
  EoL = 'SGP-ENDOC',
  MnR = 'SGP-RPRMN',
}
